import { connect } from 'dva';
import { createForm } from 'rc-form';
import { Activities } from './Activities';
import { routerRedux } from 'dva/router';

const mapStateToProps = (state, ownProps) => {
  const { loading, application, authentication } = state;
  const { profile } = authentication;
  const { activitiesList } = application

  const isLoading = loading.effects['application/fetchActivities'];
  return {
    isLoading,
    profile,
    activitiesList
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    redirect(pathname) {
      dispatch(routerRedux.push({ pathname: `${pathname}` }));
    },
    fetchActivities(data) {
      dispatch({ type: 'application/fetchActivities', payload: data });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(createForm()(Activities));
